import React from 'react'
import styled from 'styled-components'

export const SideNavListItem = props => {
  const {
    isActive,
    onClick,
    icon: Icon,
    text,
    visible
  } = props

  return visible && (
    <SideNavListItemContainer
      isActive={isActive}
      onClick={onClick}
    >
      <div className='side-nav-list-item__icon'>
        {Icon && <Icon />}
      </div>
      <div className='side-nav-list-item__text'>{text}</div>
    </SideNavListItemContainer>
  )
}

SideNavListItem.defaultProps = {
  visible: true,
  isActive: false,
  text: '',
  onClick: () => {}
}

export default SideNavListItem

const SideNavListItemContainer = styled.div`
  position: relative;
  white-space: nowrap;
  padding: 16px 0;
  cursor: pointer;
  display: flex;
  align-items: center;

  .side-nav-list-item__icon {
    flex: none;
    display: inline-block;
    width: ${props => props.theme.dimensions.navigationShrinkDrawerWidth};
    text-align: center;
    font-size: 20px;
    transition: ${props =>
      `color ${props.theme.transitions.duration.standard}ms ${props.theme.transitions.easing.easeInOut}`};
    color: ${props =>
      props.isActive
        ? props.theme.palette.primary.main
        : props.theme.palette.common.alto};
        
    ${props => props.theme.breakpointsMedia.mobile} {
      width: 20px;
      margin-right: 10px;
    }
  }

  .side-nav-list-item__text {
    white-space: nowrap;
    display: inline-block;
    color: ${props =>
      props.isActive
        ? props.theme.palette.primary.main
        : props.theme.palette.common.alto};
    transition: ${props =>
      `color ${props.theme.transitions.duration.standard}ms ${props.theme.transitions.easing.easeInOut}`};
  }

  &:hover {
    .side-nav-list-item__icon {
      color: ${props => props.theme.palette.primary.dark};
    }

    .side-nav-list-item__text {
      color: ${props => props.theme.palette.primary.dark};
    }
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 3px;
    transition: ${props =>
      `opacity ${props.theme.transitions.duration.standard}ms ${props.theme.transitions.easing.easeInOut}`};
    background-color: ${props => props.theme.palette.primary.main};
    opacity: ${props => (props.isActive ? '1' : '0')};
    
    ${props => props.theme.breakpointsMedia.mobile} {
      display: none;
    }
  }
`
